<template>
<div class="post page-container" :class="fields.uid">
  <!-- Main -->
  <main :class="['main', fields.uid]">
    <!-- Breadcrumbs -->
    <!-- <aside class="breadcrumb text-bold text-extended" style="opacity: 1;">
      <span class="page-title">{{ fields.title }}</span>
      <span id="section-title" class="section-title"></span>
    </aside> -->
    
    <!-- Ticker -->

    <div class="ticker bg-yellow loaded" data-title="News">
        <div>
            <marquee-text :duration="60">
              <h3 class="ticker-item fs-normal">News</h3>
              <span class="ticker-item performa fs-normal">Performa</span>
              <span class="ticker-item fs-normal">News</span>
              <span class="ticker-item performa fs-normal">Performa</span>
            </marquee-text>
        </div>
    </div>
        <div class="relative">
        <figure @click="showPhotoSwipe(0)" class="featured-image"  :class="fields.desktop_featured_image_crop_point">
          <prismic-image :field="fields.featured_image"/>
          <figcaption><prismic-rich-text :field="fields.featured_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
        </figure>
  
      
    <section class="page-content">
      <header>
        <h1 class="text-bold text-extended">{{ fields.title }}</h1>
        <span>Published {{ labelFormat(fields.date) }}</span>
      </header>
      

      <template v-for="(slice, index) in slices">
        <template v-if="slice.slice_type === 'text'">
          <article class="text">
	          
          <prismic-rich-text :field="slice.primary.section_text" :class="slice.primary.section_text_class"/>
                    
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'image'">
          <article>
            <figure class="img img-landscape" @click="showPhotoSwipe(index)">
              <img v-lazy="slice.primary.section_image.url" />
              <figcaption><prismic-rich-text :field="slice.primary.section_image_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
            </figure>        
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'cta'">
          <article>
              <prismic-link :field="slice.primary.cta_link" class="cta btn">
	              <strong>
              <span>{{ slice.primary.cta_text }}</span>
	              </strong>
              </prismic-link>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'video'">
          <article class="article-video">
          <figure class="img">              
          <div class="rb-video-wrap video-wrap muted">
            <video id="rb-video" playsinline="" autoplay="" loop="" muted="true" preload="auto">
              <source :src="slice.primary.video_link.url" type="video/mp4">
            </video>
          </div>
          <figcaption><prismic-rich-text :field="slice.primary.video_caption" :htmlSerializer="innerSingleParagraph"/></figcaption>
          </figure>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'horizontal_break'">
          <article>
          <hr>
          </article>
        </template>
        <template v-else-if="slice.slice_type === 'pull_quote'">
          <article>
            <aside class="pquote">
            <blockquote>
              <prismic-rich-text :field="slice.primary.quote_text" :htmlSerializer="innerSingleParagraph"/>
            </blockquote>
            <template v-if="slice.primary.quote_author">
            <prismic-rich-text :field="slice.primary.quote_author" :htmlSerializer="innerSingleParagraph" class="pquote-author"/>
            </template>
            </aside>
          </article>
        </template>
      </template>
      
			<v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>
			
    </section>
</div>
  </main>
</div>
</template>
 
<script>
import prismicDOM from 'prismic-dom';
import { PhotoSwipe, PhotoSwipeGallery } from 'v-photoswipe';
import moment from 'moment';

const Elements = prismicDOM.RichText.Elements;

const innerSingleParagraph = function (type, element, content, children) {
  if (type === Elements.paragraph) {
    return `${children.join('')}`;
  }
  return null;
};

export default {
  name: 'Post',
  data () {
    return {
	    innerSingleParagraph,
      fields: {
        uid: null,
        title: null,
        date: null,
        featured_image: null,
        featured_image_caption: null
      },
      slices: [],
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
        showHideOpacity: true,
        history: false
      },
      optionsGallery: {},
      items: []
    }
  },
  components: {
	  'v-photoswipe': PhotoSwipe,
    'v-photoswipe-gallery': PhotoSwipeGallery
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getByUID('post', uid)
        .then((document) => {
	        this.fields.uid = document.uid
          this.fields.title = document.data.title
          this.fields.date = document.data.date
          this.fields.description = document.data.excerpt
          this.fields.featured_image = document.data.featured_image
          this.fields.featured_image_url = document.data.featured_image.url
          this.fields.featured_image_caption = document.data.featured_image_caption
          this.slices = document.data.body
          this.items.push({
		          src: document.data.featured_image.url,
		          w: document.data.featured_image.dimensions.width,
		          h: document.data.featured_image.dimensions.height,
		          title: prismicDOM.RichText.asHtml(document.data.featured_image_caption, innerSingleParagraph),
		          index: 0
		        })
            
            for (var [i, slice] of this.slices.entries()) {
	            
						  if (slice.slice_type == 'image') {
							  this.items.push({
				          src: slice.primary.section_image.url,
				          w: slice.primary.section_image.dimensions.width,
				          h: slice.primary.section_image.dimensions.height,
				          title: prismicDOM.RichText.asHtml(slice.primary.section_image_caption, innerSingleParagraph),
				          index: i
				        })
						  }
						}
        })
    },
    labelFormat(date) {
			var label = moment(date);
			label = label.format('M.D.YYYY');
			return label;
		},
    showPhotoSwipe (index) {
      this.isOpen = true
      this.$set(this.options, 'index', index)
    },
    hidePhotoSwipe () {
      this.isOpen = false
    }
  },
  metaInfo () {
	  
	  if (this.fields.description == null) {
		  var description = 'Founded by RoseLee Goldberg in 2004, Performa is the leading organization dedicated to exploring the critical role of live performance in the history of twentieth-century art and to encouraging new directions in performance for the twenty-first century.';
	  } else {
		  	  var description = this.fields.description;
	  }
	  
    return {
      title: this.fields.title,
      meta: [
		    {vmid: 'description', name: 'description', content: description},
		    
		    {vmid: 'og:title', property: 'og:title', content: this.fields.title},
		    {vmid: 'og:site_name', property: 'og:site_name', content: 'Performa'},
		    // The list of types is available here: http://ogp.me/#types
		    {vmid:'og:type', property: 'og:type', content: 'website'},
		    // Should be the the same as your canonical link, see below.
		    {vmid:'og:url', property: 'og:url', content: 'https://performa-arts.org/news/' + this.fields.uid},
		    // Often the same as your meta description, but not always.
		    {vmid:'og:description', property: 'og:description', content: description},
		    {vmid:'og:image', property: 'og:image', content: this.fields.featured_image_url},
		    
		
		    {vmid: 'twitter:card', name: 'twitter:card', content: 'summary'},
		    {vmid: 'twitter:site', name: 'twitter:site', content: 'https://performa-arts.org/news/' + this.fields.uid},
		    {vmid: 'twitter:title', name: 'twitter:title', content: this.fields.title + ' - Performa'},
		    {vmid: 'twitter:description', name: 'twitter:description', content: description},
		    {vmid: 'twitter:creator', name: 'twitter:creator', content: '@PerformaNYC'},
				{vmid: 'twitter:image', name: 'twitter:image', content: this.fields.featured_image_url},
		
		    {vmid: 'itemprop-name', itemprop: 'name', content: this.fields.title + ' 	- Performa'},
		    {vmid: 'itemprop-description', itemprop: 'description', content: description}
		  ]
    }
  },
  created () {
    this.getContent(this.$route.params.postId);
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.postId);
    next();
  },
  beforeDestroy() {
    this.items = []
	}
};
</script>

<style>
	
figure {
	cursor: pointer;
}
	
.pswp__caption__center {
	color: $tru-white !important;
	line-height: 1 !important;
	max-width: 50% !important;
	font-size: 12px !important;
	pointer-events: none !important;
}

.pswp__top-bar {
	display: none;
}

</style>